import ROLES from "../../constants/roles";
import { User } from "../../@types/user.types";

export const USER_BASE_PATH = "/user";

/**
 * A user created against a single store belongs to the store scoped area, a user with
 * only a group belongs to the group wide area. Everybody else lands on the super admin
 * dashboard.
 */
export const getLandingRoute = (user: Partial<User> | null): string => {
	if (!user) {
		return "/";
	}

	// LAB is a central, read only role with no group scope: it sees STL ready scans
	// across every group, so it lands on the LAB scan list rather than a dashboard.
	if (user.role === ROLES.lab) {
		return "/lab/scans";
	}

	if (!user.group_number) {
		return "/";
	}

	// The USER role never leaves its own store's scan report list. An account with no
	// store is a misconfiguration (creation rejects it), but it still belongs in the
	// read only area rather than on a dashboard it has no business seeing.
	if (user.role === ROLES.user) {
		const storeParam = user.store_number ? `&sn=${user.store_number}` : "";
		return `${USER_BASE_PATH}?gn=${user.group_number}${storeParam}`;
	}

	if (user.role !== ROLES.admin) {
		return "/";
	}

	if (user.store_number) {
		return `/store-admin?gn=${user.group_number}&sn=${user.store_number}`;
	}

	return `/admin?gn=${user.group_number}`;
};

export const isStoreScopedUser = (user: Partial<User> | null): boolean =>
	Boolean(user && user.role === ROLES.admin && user.group_number && user.store_number);

export default getLandingRoute;
